export const holidayConstants = {
    CREATE_REQUEST: 'HOLIDAY_CREATE_REQUEST',
    CREATE_SUCCESS: 'HOLIDAY_CREATE_SUCCESS',
    CREATE_FAILURE: 'HOLIDAY_CREATE_FAILURE',

    UPDATE_REQUEST: 'HOLIDAY_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'HOLIDAY_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'HOLIDAY_UPDATE_FAILURE',

    REMOVE_REQUEST: 'HOLIDAY_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'HOLIDAY_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'HOLIDAY_REMOVE_FAILURE',

    FETCH_REQUEST: 'HOLIDAY_FETCH_REQUEST',
    FETCH_SUCCESS: 'HOLIDAY_FETCH_SUCCESS',
    FETCH_FAILURE: 'HOLIDAY_FETCH_FAILURE',

    GET_REQUEST: 'HOLIDAY_GET_REQUEST',
    GET_SUCCESS: 'HOLIDAY_GET_SUCCESS',
    GET_FAILURE: 'HOLIDAY_GET_FAILURE',
};

// Mirrors Holiday.HolidayScope on the backend (AgulhasNegras/Models/Holiday.cs)
export const holidayScopeOptions = [
    { key: 0, value: 0, text: 'Nacional' },
    { key: 1, value: 1, text: 'Estadual' },
    { key: 2, value: 2, text: 'Municipal' },
];
